export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/slowOverlay.worker.8491a8b4.worker.js");
}
